export { default } from './HeroMonthlyHistogramContainer';
